import styled from "styled-components";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
/**
 * Q&Aダイアログのスタイルコンポーネント
 */
const QaDialogStyles = {
  Container: styled.div`
    width: 100%;
  `,
  FlexRow: styled.div`
    display: flex;
    flex-direction: row;
    gap: 0;
  `,
  // フレックス間隔
  FlexBetween: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0;
  `,
  Dialog: styled(Dialog)`
    background: url(/images/bg.png) 0 0;
  `,
  DialogTitle: styled(DialogTitle)`
    background: url(/images/bg.png) 0 0;
  `,
  DialogContent: styled(DialogContent)`
    background: url(/images/bg.png) 0 0;
  `,
  Title: styled.div`
    background: url(/images/window_title.png) no-repeat 0 50%;
    padding: 5px 0 0 35px;
    color: #333;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 10px;
  `,

  OrderDetail: styled.div`
    position: relative;
    background-color: #ffa;
    border: 1px solid #f93;
    border-radius: 5px;
    color: #333;
    line-height: 33px;
    padding: 0 5px;
    clear: right;
    overflow: hidden;
  `,

  OrderDetailList: styled.dl`
    &::after {
      content: "";
      display: table;
      clear: both;
    }
  `,

  OrderDetailItem: styled.div`
    background-color: #ffa;
    &::after {
      content: "";
      display: table;
      clear: both;
    }
  `,

  OrderDetailLabel: styled.dt`
    background-color: #ffa;
    font-weight: bold;
    float: left;
    padding-right: 5px;
    margin: 0;
    font-size: 18px;

    &.order {
      clear: both;
      float: left;
    }
  `,

  OrderDetailValue: styled.dd`
    color: #f00;
    float: left;
    padding-right: 15px;
    font-size: 18px;
    margin: 0;
  `,

  AnsSpan: styled.span`
    display: inline-block;
    margin-right: 4px;

    background: #36f;
    color: #fff;
    font-weight: bold;
    padding: 2px 5px;
    border-radius: 2px;
  `,
  FaqSection: styled.div`
    margin-bottom: 20px;
    .que {
      display: inline-block;
      font-weight: bold;
      color: #333;
      margin-right: 4px;
      background: #f33;
      color: #fff;
      padding: 2px 5px;
      border-radius: 2px;
    }

    .ans {
      display: inline-block;
      margin-right: 4px;

      background: #36f;
      color: #fff;
      font-weight: bold;
      padding: 2px 5px;
      border-radius: 2px;
    }
    dt {
      margin-bottom: 6px;
      background: #ffe4e4;
      padding: 4px;
    }

    dd {
      margin: 0 0 6px 0;
      padding: 4px 4px 4px 30px;
    }

    .order-complete {
      margin-top: 10px;
    }
    h3 {
      padding: 5px 0 0 5px;
      color: #333;
      font-size: 20px;
      line-height: 30px;
      margin: 30px 0 10px;
      font-weight: bold;
      border-left: 5px solid #f33;
    }
  `,
  ConfirmSection: styled.div`
    margin-bottom: 20px;

    .que {
      display: inline-block;
      font-weight: bold;
      color: #333;
      margin-right: 4px;
      background: #f33;
      color: #fff;
      padding: 2px 5px;
      border-radius: 2px;
    }

    .ans {
      display: inline-block;
      margin-right: 4px;

      background: #36f;
      color: #fff;
      font-weight: bold;
      padding: 2px 5px;
      border-radius: 2px;
    }
    dt {
      margin-bottom: 6px;
      background: #ffe4e4;
      padding: 4px;
    }

    dd {
      margin: 0 0 6px 0;
      padding: 4px 4px 4px 30px;
    }

    .order-complete {
      margin-top: 10px;
      text-align: center;
    }
    h3 {
      padding: 5px 0 0 5px;
      color: #333;
      font-size: 20px;
      line-height: 30px;
      margin: 30px 0 10px;
      font-weight: bold;
      border-left: 5px solid #f33;
    }
  `,

  FinishSection: styled.div`
    margin-bottom: 20px;
    text-align: left;

    h3 {
      padding: 5px 0 0 5px;
      color: #333;
      font-size: 20px;
      line-height: 30px;
      margin: 30px 0 10px;
      font-weight: bold;
      border-left: 5px solid #f33;
    }

    .order-complete {
      margin-top: 10px;
      text-align: center;
    }
  `,

  SimpleTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    margin-bottom: 20px;

    th {
      border: 1px solid #999;
      padding: 2px;
      text-align: center;
      background: #e4ebff;
    }
    td {
      border: 1px solid #999;
      padding: 6px 8px;
      vertical-align: top;
      padding: 2px;
      text-align: center;
      background: #ffffff;
    }

    .date,
    .locale,
    .ctrl {
      text-align: center;
    }

    .txt {
      word-break: break-all;
      text-align: left;
      width: 55%;
      text-wrap: normal;
    }
  `,

  GrayBtn: styled.button`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border-style: solid;
    border-width: 1px;
    border-color: #eee #999 #999 #eee;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
  `,

  AnswerBlock: styled.div`
    /* background: #fff; */
    padding: 8px 0;

    .que {
      display: inline-block;
      font-weight: bold;
      color: #333;
      margin-right: 4px;
      background: #f33;
      color: #fff;
      padding: 2px 5px;
      border-radius: 2px;
    }

    .ans {
      display: inline-block;
      font-weight: bold;
      color: #333;
      margin-right: 4px;
    }

    dt {
      margin-bottom: 6px;
      background: #ffe4e4;
      padding: 4px;
    }

    dd {
      margin: 0 0 6px 0;
    }

    .order-complete {
      margin-top: 10px;
    }
    h3 {
      padding: 5px 0 0 5px;
      color: #333;
      font-size: 20px;
      line-height: 30px;
      margin: 30px 0 10px;
      font-weight: bold;
      border-left: 5px solid #f33;
    }
  `,

  Textarea: styled.textarea`
    width: 99%;
    height: 100px;
    padding: 8px;
    border: 1px solid #ccc;
    resize: vertical;
    background: #fff;
    margin-bottom: 8px;
  `,

  WarningBox: styled.div`
    background-color: #ffff00;
    padding: 8px;
    margin-top: 6px;

    ul {
      padding-left: 18px;
      margin: 0;
    }
  `,

  ImportantBtn: styled.button`
    display: inline-block;
    background: #ff3333 url(/images/arrow_important.png) no-repeat 10px 50%;
    color: #fff;
    height: 33px;
    border-style: solid;
    border-width: 1px;
    border-color: #ffe4e4 #ac1d1f #ac1d1f #ffe4e4;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px 0 30px;
    cursor: pointer;
  `,
};

export default QaDialogStyles;
